import * as t from "io-ts"
import { UUID } from "io-ts-types/lib/UUID"
import { cast, LocalDate, maybe } from "@flockcover/flock-svc-core-types"
import { StatusType } from "@shared/types"

const baseFragment = {
  registrationNumber: t.string,
  onCoverDate: LocalDate,
  offCoverDate: maybe(LocalDate),
}
const BaseFragmentType = t.type(baseFragment)
export type BaseFragment = t.TypeOf<typeof BaseFragmentType>

const resolvedFragment = {
  vehicleId: UUID,
  make: t.string,
  model: t.string,
  fuelType: maybe(t.string),
  abiCode: maybe(t.string),
  abiGroup: maybe(t.number),
  grossWeight: maybe(t.number),
  nominalStartYear: maybe(t.number),
  numberOfSeats: maybe(t.number),
  trim: maybe(t.string),
  type: t.string,
}

const ResolvedFragmentType = t.type(resolvedFragment)
export type ResolvedFragment = t.TypeOf<typeof ResolvedFragmentType>

export type BaseFleetEntry = BaseFragment
export type AddedFleetEntry = BaseFragment & Partial<ResolvedFragment> & { uniqueRef?: string }
export type ResolvedFleetEntry = BaseFragment & ResolvedFragment

// NOTE: uniqueRef is for use in the frontend, vehicle ids may not be unique
// so we generated a uniqueRef using a combo for VRN, onCoverDate, offCoverDate
// when pulling in the data from the backend.
const UniqueRefType = t.union([t.string, t.undefined])

const FleetEntryType = t.type({
  ...baseFragment,
  ...resolvedFragment,
  id: t.string,
  sentToMID: maybe(LocalDate),
  status: StatusType,
  uniqueRef: UniqueRefType,
  isConnected: t.boolean,
  createdAt: maybe(LocalDate),
})

const FleetType = t.readonlyArray(FleetEntryType)

export type UniqueRef = t.TypeOf<typeof UniqueRefType>
export type FleetEntry = t.TypeOf<typeof FleetEntryType>
export type Fleet = t.TypeOf<typeof FleetType>
export const makeFleet = cast(FleetType)
export const makeFleetEntries = cast(t.readonlyArray(FleetEntryType))
